/**
 * Shared query keys and cache defaults for React Query.
 *
 * Same key = shared cache. Any component that needs "categories" uses CATEGORIES_QUERY_KEY;
 * the first useQuery fetches, others read from cache until data is stale or invalidated.
 *
 * staleTime: while fresh, React Query won't refetch when another component mounts with the
 * same key. After mutations (create/update/delete) we invalidate so the next read refetches.
 */

export const PRODUCTS_QUERY_KEY = ['products'];

/** Product categories list – used by Category form and by Products form (category dropdown). */
export const CATEGORIES_QUERY_KEY = ['product-categories'];

/** Suppliers list – used by Suppliers form (dropdown in edit mode). */
export const SUPPLIERS_QUERY_KEY = ['suppliers'];

/** Consider list data fresh for 1 hour so multiple consumers share cache without refetching. */
export const LIST_STALE_TIME_MS = 60 * 60 * 1000;
